import * as React from "react";
import {Modal} from "../../Modal";
import Button from "../../Button";
import './PreviewTechSheetModal.css';
import {connect} from "react-redux";
import { changeZoom } from '../../../actions/actions';
import { ITechSheet } from "src/infrastructure/interfaces";
import { contentImagesRelativePath } from 'src/constants';

export interface PreviewTechSheetProps {
    show: any;
    onClose: any;
    techSheet: ITechSheet;
}

export interface PreviewTechSheetState {
}

const mapDispatchToProps = (dispatch: any): any => {
    return {
      resetZoom: (type: string) => {
        dispatch(changeZoom(type));
      },
    };
  };
  

const mapStateToProps = (state: any): any => {
    return {
    };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class PreviewTechSheetModal extends React.Component<PreviewTechSheetProps, PreviewTechSheetState> {

    closeModal = () => this.setState({ showModal: false});

    render() {
        return (
            <Modal show={this.props.show}
                   onClose={this.props.onClose}
                   className="extra-large-modal"
            >
                <Modal.Body>
                    <div className={"techSheetPreviewContainer"}>
                        <img className="techSheetPreviewImage" alt="Tech Sheet" src={contentImagesRelativePath + this.props.techSheet.image_path} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsClass="cancel" onClick={this.props.onClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Modals/PreviewTechSheetModal/PreviewTechSheetModal.tsx